// @generated by TypeGen from LogbookModel/ShipUser.swift - DO NOT EDIT

export interface IShipUser {
  id: number;
  accountId: number;
  userId?: number;
  shipId: number;
  createdAt: string;
  updatedAt: string;
  syncedAt?: string;
  deletedAt?: string;
  active: number;
  data: string;
  name?: string;
  shipUserLevel: IShipUserLevel;
  shipUserCrewRole: IShipUserCrewRole;
  shortname?: string;
  status?: IShipUserStatus;
  email?: string;
}

export interface IShipUserData {
  passportNumber?: string;
}

export interface IShipUserResponse {
  user: IShipUser;
}

export interface IShipUsersResponse {
  users: IShipUser[];
}

export enum IShipUserCrewRole {
  none = 0,
  crew = 10,
  skipper = 20,
  owner = 100,
}

export enum IShipUserLevel {
  none = 0,
  viewCurrent = 1,
  viewAll = 2,
  editCurrent = 10,
  editAll = 11,
  primary = 100,
}

export enum IShipUserStatus {
  active = "active",
  invited = "invited",
}

export type IShipUserParsed = Omit<IShipUser, "data"> & { dataParsed: IShipUserData };

export const ShipUser = {
  parse(r: IShipUser): IShipUserParsed {
    return { ...r, dataParsed: r.data != null ? JSON.parse(r.data) : {} } as IShipUserParsed;
  },
};
